module.exports = __webpack_public_path__ + "static/img/dongguan.07d7720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/dongguan.png
// module id = enxN
// module chunks = 93